<template>
    <div class="container-fluid " style="padding-bottom: 50px;">
      <div class="row" style="padding-top:10px; background-color: #F3F4F7;">
        <div class="col-6" style="font-size: x-small; padding-bottom: 10px;">
          <template v-if="legalName"><strong>{{legalName}}</strong><template v-if="legalName !== item.title"><br>trade as </template></template>
          <strong v-if="!legalName || legalName !== item.title">{{item.title}}</strong><br>{{item.contact}}<br><span v-html="item.addressText"></span>
        </div>
        <div class="col-6 tnc-btn" style="font-size:  x-small; padding-bottom: 10px; vertical-align: center;">
          <span class="footer-link" v-on:click="openTnc">Terms & Conditions</span>
          <span class="footer-link footer-link-next" v-on:click="openPrivacy">Privacy policy</span>
        </div>

      </div>
      <div class="row" v-if="item.webSetting !== undefined && item.webSetting !== null && item.webSetting.footerMessage !== null">
        <div class="col-12" v-html="item.webSetting.footerMessage"></div>
      </div>
      <div class="row" style="padding-top:10px;background: #F3F3F3; padding-bottom: 50px;">
        <div class="col-12" style="font-size:  x-small; margin-bottom: 10px;">
          Copyright @2020 <strong>{{item.title}}</strong>. All rights reserved
        </div>
        <div class="col-12" style="font-size:  x-small">
          Powered by <strong>Show Me The Menu</strong>
          <br>Borium Studio Limited
        </div>
        <div class="col-6" style="display: none;">
          <img style="height:25px;" src="https://storage.googleapis.com/menus-275719.appspot.com/logos/borium-logo-blue.png"/>
        </div>
      </div>
    </div>
</template>

<script>
    import EventBus from "../api/event-bus";

    export default {
        name: "Bottom",
      props: {
        item: {
          type: Object,
          default: function() {
            return{}
          }
        }
      },
      data() {
        return {
          isEemo:false,
        }
      },
      computed: {
          legalName: function() {
            var name = this.item && this.item.registeredTitle;
            if (name && String(name).length > 0) {
              return name;
            }
            return "";
          }
      },
      created() {
          // console.log("bottom item");
          // console.log(this.item);
          this.item.addressText = this.item.address.replace(/\n/g, '<br />');
          if(window.location.host === 'eemo.app') {
            this.$data.isEemo = true;
          }
      },
      mounted() {
      },
      methods: {
          openTnc: function() {
            EventBus.$emit("showTnCs", this.item);

          },
          openPrivacy: function() {
            EventBus.$emit("showPrivacy", this.item);
          }

      }
    }
</script>

<style scoped>

  .no-tnc .tnc-btn {
    display: none;
  }
  .footer-link {
    display: block;
    font-weight: bold;
    cursor: pointer;
  }
  .footer-link-next {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue